import { useDispatch } from 'react-redux';
import { Col, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    getPositionList,
    // getPositionQuery,
} from '../../../slices/thunks';
import { Link } from 'react-router-dom';
// import AddEditPositionModal from './Add_Edit/AddEditPositionModal';
// import DeletePositionModal from './Delete/DeletePosition';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';
import { to } from 'react-spring';
import AddEditPositionModal from './Add_Edit/AddEditPositionModal';

const PositionsList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectorPositions = createSelector(
        state => state.Positions,
        data => ({
            dataList: data.PositionList,
            isLoadingList: data.isLoadingList,
            isPersonalProtectiveEquipmentSuccess:
                data.isPersonalProtectiveEquipmentSuccess,
            error: data.error,
            isAdding: data.isAdding,
            isAdded: data.isAdded,
            isAddError: data.isAddError,
            isUpdating: data.isUpdating,
            isUpdated: data.isUpdated,
            isUpdateError: data.isUpdateError,
            isDeleting: data.isDeleting,
            isDeleted: data.isDeleted,
            isDeleteError: data.isDeleteError,
        })
    );
    
    const { dataList, isLoadingList } = useSelector(selectorPositions);

    // const selectRolesList = createSelector(
    // 	state => state.Roles.roleListSelect,
    // 	roleListSelect => roleListSelect
    // );

    // const roleListSelect = useSelector(selectRolesList);

    useEffect(() => {
        dispatch(getPositionList());
        
    }, []);

    const [dataPosition, setDataPosition] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    // Delete Position
    const [modal, setModal] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    //Tab
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    function handleToggleModal() {
        setModal(!modal);
        toggleTab('1');
        // validation.resetForm();
    }

    function handleToggleModalDelete() {
        setModalDelete(!modalDelete);
    }

    // Delete Data
    const handleClickDelete = Position => {
        setDataPosition(Position);
        setModalDelete(true);
    };

    // Update Data
    const handleClickEdit = Position => {
        setDataPosition(Position);
        handleToggleModal();
    };

    const columns = useMemo(
        () => [
            {
                header: 'Acciones',
                enableSorting: false,
                enableColumnFilter: false,
                enableGlobalFilter: false,
                enableColumnActions: false,
                accessorKey: 'Position',
                columnDefType: 'display',

                size: 'auto',
                Cell: cellProps => {
                    return (
                        <React.Fragment>
                            <div className='d-flex'>
                                <div className='flex-shrink-0'>
                                    <ul className='list-inline mb-0'>
                                        <li className='list-inline-item'>
                                            <Link
                                                to='#'
                                                onClick={() => {
                                                    const PositionData =
                                                        cellProps.row.original;
                                                    setIsEdit(true);
                                                    handleClickEdit(PositionData);
                                                }}
                                            >
                                                <i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
                                            </Link>
                                        </li>
                                        <li className='list-inline-item'>
                                            <Link
                                                to='#'
                                                className='remove-item-btn'
                                                onClick={() => {
                                                    const PositionData =
                                                        cellProps.row.original;
                                                    handleClickDelete(PositionData);
                                                }}
                                            >
                                                <i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
            { header: 'Nombre', accessorKey: 'name', size: 'auto' },
            // {
            // 	header: 'Desactivado',
            // 	accessorKey: 'disable',
            //
            // 	size: 'auto',
            // 	visible: false,
            // 	Cell: ({ row }) => {
            // 		return (
            // 			<input
            // 				className='form-check-input'
            // 				role='switch'
            // 				type='checkbox'
            // 				id='disabled'
            // 				name='disabled'
            // 				disabled
            // 				checked={row.original.disable}
            // 			/>
            // 		);
            // 	},
            // },
        ],
        [handleClickEdit]
    );

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        {/* <CardHeader className='border-0 pb-0'>
                            <div className='d-flex align-items-end justify-content-end'>
                                <div className='flex-shrink-0'>
                                    <div className='d-flex flex-wrap gap-2'>
                                        <button
                                            className='btn btn-label btn-primary'
                                            onClick={() => {
                                                setIsEdit(false);
                                                setDataPosition({});
                                                handleToggleModal();
                                            }}
                                        >
                                            <i className='ri-add-line label-icon'></i>{' '}
                                            Crear Establecimiento
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </CardHeader> */}
                        <CardBody className='pt-3'>
                            <ODataGrid
                                columns={columns}
                                data={dataList || []}
                                customToolbarActions={[
                                    {
                                        label: 'Crear',
                                        icon: 'ri-add-line',
                                        onClick: () => {
                                            setIsEdit(false);
                                            setDataPosition({});
                                            handleToggleModal();
                                        },
                                        title: 'Crear Cargo'
                                    }
                                ]}
                                nameFile={'establecimiento'}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <AddEditPositionModal
                dataPosition={dataPosition}
                isEdit={isEdit}
                isOpen={modal}
                handleToggleModal={handleToggleModal}
                activeTab={activeTab}
                toggleTab={toggleTab}
            />

            {/* <AddEditPositionModal
                dataPosition={dataPosition}
                isEdit={isEdit}
                isOpen={modal}
                handleToggleModal={handleToggleModal}
                activeTab={activeTab}
                toggleTab={toggleTab}
            />
            <DeletePositionModal
                dataPosition={dataPosition}
                isOpen={modalDelete}
                handlerToggleModal={handleToggleModalDelete}
            /> */}
        </React.Fragment>
    );
};

export default PositionsList;
